import { inter } from "../fonts/inter.ts";
import { motion } from "framer-motion";
import HeroBackground from "../components/background/HeroBackground.tsx";
import React from "react";
import AnimatedTitle from "../animations/AnimatedTitle.tsx";
import AnimatedBody from "../animations/AnimatedBody.tsx";


type HeroProps = {
    bts?: boolean;
};

const Hero = ({bts = false}: HeroProps = {}) => {
    return (
        <motion.section
            className="relative z-10 flex h-[100vh] w-full justify-center"
            id="home"
            initial="initial"
            animate="animate"
        >
            <HeroBackground />
            <div className="mt-10 flex flex-col items-center justify-center sm:mt-0 text-[#e4ded7]">
                <div
                    className={`relative flex flex-col items-center justify-center ${inter.className} w-full`}
                >
                    {bts && (
                        <span className="mb-4 inline-block rounded-full border border-[#444] bg-[#222] px-4 py-1 text-[11px] font-semibold uppercase tracking-wider text-[#e4ded7] sm:text-[12px] md:text-[13px]">
                            Portfolio BTS SIO
                        </span>
                    )}
                    <AnimatedTitle
                        text={"Neil Broneer"}
                        className={
                            "mb-6 text-center text-[40px] font-bold leading-tight text-[#e4ded7] sm:text-[45px] md:text-[60px] lg:text-[80px]"
                        }
                        wordSpace={"mr-[14px]"}
                        charSpace={"mr-[0.001em]"}
                    />
                    <div className="mb-6 max-w-xl text-center flex flex-col gap-2 text-[#e4ded7]">
                        <AnimatedBody text="Développeur Fullstack & Builder, je conçois des solutions web sur-mesure et lance mes propres projets." className="text-[#e4ded7]" />
                        <AnimatedBody
                            delay={0.1}
                            text="Autodidacte, avec un parcours entre développement et entrepreneuriat. Je développe avec des technologies modernes et crée des projets de A à Z"
                            className="text-[#e4ded7]"
                        />
                    </div>
                    <div className="flex flex-wrap gap-3 justify-center mb-4 items-center">
                        <span className="px-4 py-2 bg-[#222] rounded-full text-[#e4ded7] text-sm font-medium">Next.js</span>
                        <span className="px-4 py-2 bg-[#222] rounded-full text-[#e4ded7] text-sm font-medium">Claude Code</span>
                        <span className="px-4 py-2 bg-[#222] rounded-full text-[#e4ded7] text-sm font-medium">TypeScript</span>
                        <span className="px-4 py-2 bg-[#222] rounded-full text-[#e4ded7] text-sm font-medium">React</span>
                    </div>
                    <div className="flex flex-wrap gap-4 justify-center mb-4 text-[#bdbdbd] text-sm">
                        <span>📍 Paris</span>
                        <span>Freelance</span>
                        <span>+2 ans d'expérience</span>
                    </div>
                </div>
            </div>
            {/* Animation scroll down en bas de la Hero */}
            <div className="absolute bottom-24 left-0 w-full flex flex-col items-center pointer-events-none select-none z-20">
                <div className="flex flex-col items-center gap-1">
                    <span className="text-[#bdbdbd] text-xs sm:text-sm font-light tracking-wide">Scroll down</span>
                    <div className="flex flex-col items-center mt-1">
                        {[0, 1, 2].map((i) => (
                            <motion.svg
                                key={i}
                                className="w-5 h-5 text-[#bdbdbd]"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                viewBox="0 0 24 24"
                                initial={{ opacity: 0, y: -8 }}
                                animate={{ opacity: [0, 1, 1, 0], y: [ -8, 0, 8, 16 ] }}
                                transition={{
                                    duration: 1.2,
                                    repeat: Infinity,
                                    delay: i * 0.18,
                                    ease: "easeInOut"
                                }}
                                style={{ marginTop: i === 0 ? 0 : -6 }}
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                            </motion.svg>
                        ))}
                    </div>
                </div>
                {/* Bouton subtil sous l'animation */}
                <button
                    className="mt-2 px-3 py-1 rounded-full text-[#bdbdbd] text-xs font-medium bg-transparent border border-[#444] hover:bg-[#222] hover:text-[#e4ded7] transition pointer-events-auto"
                    style={{ opacity: 0.7 }}
                    onClick={() => {
                        const toolsSection = document.getElementById('tools');
                        if (toolsSection) {
                            toolsSection.scrollIntoView({ behavior: 'smooth' });
                        }
                    }}
                    aria-label="Voir la stack technique complète"
                >
                    Voir la stack technique
                </button>
            </div>
        </motion.section>
    );
};

export default Hero;
